/* maks-szukajka: glowny skrypt sekcji. Wartosci z Liquid czyta z
   <script type="application/json" data-szv-cfg> w korzeniu sekcji. */
var SZVCFG = function () {
  var el = document.querySelector('[data-szv-cfg]');
  try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
};
var SZV_INIT = function () {
(function () {
    var root = document.querySelector('[data-sz-root]');
    if (!root) return;
    if (root.getAttribute('data-sz-on') === '1') return;
    root.setAttribute('data-sz-on', '1');

    var MIN = SZVCFG().k6;
    var WAIT = 220;
    var KEY = SZVCFG().rk || 'maks_ostatnie';
    var LIMIT = SZVCFG().k7;
    var COLL = SZVCFG().k1;
    var VENDOR = SZVCFG().k2;
    var RECENT_MAX = SZVCFG().k8;
    var CHIPS = SZVCFG().k3;
    var TAKEOVER = SZVCFG().k4;
    var GRAB = SZVCFG().k5;
    var OFFSET = SZVCFG().k9;
    var LOC = SZVCFG().k10;
    var CUR = SZVCFG().k11;
    var BASE = SZVCFG().k12;
    var SEARCH = SZVCFG().k13;
    var T_PROD = SZVCFG().k14;
    var T_COLL = SZVCFG().k15;
    var T_EMPTY = SZVCFG().k16;
    var T_WAIT = SZVCFG().k17;
    var T_FROM = SZVCFG().k18;
    var TRIG = '[data-maks-szukaj], [data-ng-open="search"], .searchIcn';

    var panel = root.querySelector('[data-sz-panel]');
    var form = root.querySelector('[data-sz-form]');
    var field = root.querySelector('[data-sz-field]');
    var start = root.querySelector('[data-sz-start]');
    var res = root.querySelector('[data-sz-res]');
    var allLink = root.querySelector('[data-sz-all]');
    var recentBox = root.querySelector('[data-sz-recent]');
    var recentList = root.querySelector('[data-sz-list]');
    var clearBtn = root.querySelector('[data-sz-clear]');
    var lastFocus = null;
    var lockY = 0;
    var lockOwn = false;
    var timer = null;
    var closeTimer = null;
    var ctrl = null;
    var cursor = -1;
    var vv = window.visualViewport || null;

    function each(list, fn) { Array.prototype.forEach.call(list, fn); }

    function esc(v) {
        return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function trim(v) { return String(v == null ? '' : v).replace(/^\s+|\s+$/g, ''); }

    function money(v) {
        var s = String(v == null ? '' : v).replace(/[^0-9.,-]/g, '');
        var m = s.match(/[.,](\d{1,2})$/);
        if (m) s = s.slice(0, m.index).replace(/[.,]/g, '') + '.' + m[1];
        else s = s.replace(/[.,]/g, '');
        var n = parseFloat(s);
        if (!isFinite(n)) return '';
        try {
            /* Sama liczba plus waluta z tylu - styl 'currency' przy angielskiej
               lokalizacji dawal 'PLN 879' zamiast '879 PLN'. */
            return new Intl.NumberFormat(LOC, {
                minimumFractionDigits: 0, maximumFractionDigits: 0
            }).format(n) + ' ' + CUR;
        } catch (e) {
            return String(Math.round(n)) + ' ' + CUR;
        }
    }

    function thumbUrl(u) {
        if (!u) return '';
        return String(u).replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
    }

    /* ---------- warstwa ---------- */

    function headBottom() {
        var edge = 0;
        each(document.querySelectorAll('[data-ng-head], .shopify-section-group-header-group'), function (n) {
            var r = n.getBoundingClientRect();
            if (r.height > 0 && r.bottom > edge) edge = r.bottom;
        });
        return edge;
    }

    /* SJ 16.10: na telefonie w naglowku jest szeroki przycisk-pole "Wyszukaj produkty" - warstwa
       zaczyna sie na jego wysokosci i przykrywa go wlasnym polem (bylo: dwa pola jedno pod drugim). */
    function pillTop() {
        if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return -1;
        var p = document.querySelector('[data-ng-head] [data-ng-open="search"]');
        if (!p) return -1;
        var r = p.getBoundingClientRect();
        if (r.width < 160 || r.height <= 0 || r.bottom <= 0) return -1;
        return r.top - 12;
    }

    function setTop() {
        var pt = pillTop();
        var t = pt >= 0 ? pt : headBottom() + OFFSET;
        if (t < 0) t = 0;
        root.style.setProperty('--sz-top', Math.round(t) + 'px');
    }

    function setHeight() {
        if (!vv) return;
        root.style.setProperty('--sz-h', Math.round(vv.height) + 'px');
    }

    function locked() {
        var doc = document.documentElement;
        return doc.classList.contains('ng-locked') || document.body.style.position === 'fixed';
    }

    function lock(on) {
        var doc = document.documentElement;
        var b = document.body;
        if (on) {
            if (lockOwn || locked()) return;
            var sw = window.innerWidth - doc.clientWidth;
            lockY = window.pageYOffset || doc.scrollTop || 0;
            b.style.position = 'fixed';
            b.style.top = (-lockY) + 'px';
            b.style.left = '0';
            b.style.right = '0';
            b.style.width = '100%';
            if (sw > 0) doc.style.paddingRight = sw + 'px';
            lockOwn = true;
        } else {
            if (!lockOwn) return;
            lockOwn = false;
            doc.style.paddingRight = '';
            b.style.position = '';
            b.style.top = '';
            b.style.left = '';
            b.style.right = '';
            b.style.width = '';
            window.scrollTo(0, lockY);
        }
    }

    function focusField() {
        if (!field) return;
        try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
        try { field.select(); } catch (e) {}
    }

    function open() {
        if (root.classList.contains('is-open')) return;
        window.clearTimeout(closeTimer);
        if (root.hidden) lastFocus = document.activeElement;
        setTop();
        setHeight();
        root.hidden = false;
        lock(true);
        paintRecent();
        paintClear();
        focusField();
        window.requestAnimationFrame(function () { root.classList.add('is-open'); setTop(); setHeight(); });
        window.setTimeout(function () { if (!root.hidden) { root.classList.add('is-open'); setTop(); setHeight(); } }, 60);
        window.setTimeout(focusField, 120);
    }

    function close() {
        if (root.hidden) return;
        window.clearTimeout(closeTimer);
        root.classList.remove('is-open');
        lock(false);
        closeTimer = window.setTimeout(function () {
            if (!root.classList.contains('is-open')) root.hidden = true;
        }, 320);
        each(document.querySelectorAll(TRIG), function (b) {
            b.setAttribute('aria-expanded', 'false');
        });
        if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    window.maksSzukajka = { open: open, close: close };

    /* ---------- ostatnio ogladane ---------- */

    function readStore() {
        var arr = [];
        try { arr = JSON.parse(window.localStorage.getItem(KEY)) || []; } catch (e) { arr = []; }
        return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    }

    function soloStart(hasRecent) {
        if (!start) return;
        if (CHIPS && hasRecent) start.classList.remove('sz-solo');
        else start.classList.add('sz-solo');
    }

    function paintClear() {
        if (!clearBtn) return;
        clearBtn.hidden = !(field && field.value.length);
    }

    function paintRecent() {
        if (!recentBox || !recentList) return;
        var arr = readStore();
        var html = '';
        var n = 0;
        for (var i = 0; i < arr.length && n < RECENT_MAX; i++) {
            var it = arr[i];
            if (!it || !it.u || !it.t) continue;
            n++;
            html += '<a class="sz-tile" href="' + esc(it.u) + '">'
                + '<span class="sz-tile-media">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy" width="240" height="240">' : '') + '</span>'
                + '<span class="sz-tile-txt">'
                + (VENDOR && it.b ? '<span class="sz-vendor">' + esc(it.b) + '</span>' : '')
                + '<span class="sz-name">' + esc(it.t) + '</span>'
                + (it.p ? '<span class="sz-price">' + esc(it.p) + '</span>' : '')
                + '</span></a>';
        }
        var suggBox = root.querySelector('[data-sz-sugg]');
        if (!html) {
            recentBox.hidden = true;
            recentList.innerHTML = '';
            if (suggBox) suggBox.hidden = false;
            soloStart(!!suggBox);
            return;
        }
        recentList.innerHTML = html;
        recentBox.hidden = false;
        if (suggBox) suggBox.hidden = true;
        soloStart(true);
    }

    /* ---------- wyniki ---------- */

    function rowHtml(p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var pic = thumbUrl(img);
        var lo = money(p.price_min || p.price);
        var hi = money(p.price_max || p.price);
        var price = lo && hi && lo !== hi ? T_FROM + ' ' + lo : lo;
        return '<a class="sz-row" href="' + esc(p.url) + '">'
            + '<span class="sz-media">' + (pic ? '<img src="' + esc(pic) + '" alt="" loading="lazy" width="240" height="240">' : '') + '</span>'
            + '<span class="sz-txt">'
            + (VENDOR && p.vendor ? '<span class="sz-vendor">' + esc(p.vendor) + '</span>' : '')
            + '<span class="sz-name">' + esc(p.title) + '</span>'
            + (price ? '<span class="sz-price">' + esc(price) + '</span>' : '')
            + '</span></a>';
    }

    function showStart(on) {
        if (start) start.hidden = !on;
        if (res) res.hidden = on;
        /* tryb "jak aplug": puste pole nie rozwija panelu, wiec CSS musi wiedziec,
           w ktorym stanie jestesmy */
        root.classList.toggle('sz-start-on', !!on);
    }

    function setAll(term) {
        if (!allLink) return;
        if (term.length < MIN) { allLink.hidden = true; return; }
        /* SJ 16.10: sort_by=relevance (domyslna kolejnosc) - link do wynikow nie przechodzi na kategorie o tej samej
           nazwie (sections/maks-kolekcja.liquid); Enter w polu przechodzi jak dotad */
        allLink.href = ((typeof window.ngSearchUrl === 'function')
            ? window.ngSearchUrl(term)
            : SEARCH + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last') + '&sort_by=relevance';
        allLink.hidden = false;
    }


    /* Produkty dzieciece maja tag "kids", a kolekcje handle z "kids" albo "dla-dzieci".
       W podpowiedziach odsiewamy je po stronie przegladarki, bo dopisanie
       "NOT tag:kids" do zapytania psuje dopasowanie po przedrostku
       (wpisane "ni" przestaje znajdowac Nike). */
    function bezDzieci(lista) {
        return (lista || []).filter(function (x) {
            var t = x.tags || [];
            for (var i = 0; i < t.length; i++) {
                if (String(t[i]).toLowerCase() === 'kids') return false;
            }
            return true;
        });
    }
    function bezDzieciKol(lista) {
        return (lista || []).filter(function (x) {
            var s = (String(x.handle || '') + ' ' + String(x.url || '') + ' ' + String(x.title || '')).toLowerCase();
            return s.indexOf('kids') < 0 && s.indexOf('dla-dzieci') < 0 && s.indexOf('dla dzieci') < 0;
        });
    }

    function render(data, term) {
        if (!res) return;
        var r = (data && data.resources && data.resources.results) || {};
        /* SJ 16.10: kolekcje z odpowiedzi do skrotu Enter -> kategoria (assets/maks-naglowek.js, obsluga wysylki formularza) */
        if (window.sjKolZnane) window.sjKolZnane(r.collections);
        var prods = bezDzieci(r.products);
        var colls = COLL ? bezDzieciKol(r.collections) : [];
        var left = '';
        var right = '';
        var i;
        if (prods.length) {
            left = '<span class="sz-head">' + esc(T_PROD) + '</span><div class="sz-rows">';
            for (i = 0; i < prods.length; i++) left += rowHtml(prods[i]);
            left += '</div>';
        }
        if (colls.length) {
            right = '<span class="sz-head">' + esc(T_COLL) + '</span><div class="sz-chips">';
            for (i = 0; i < colls.length; i++) {
                right += '<a class="sz-chip" href="' + esc(colls[i].url) + '">' + esc(colls[i].title) + '</a>';
            }
            right += '</div>';
        }
        if (!left && !right) {
            res.innerHTML = '<p class="sz-note">' + esc(T_EMPTY) + '</p>';
            res.classList.add('sz-solo');
        } else {
            res.innerHTML = '<div class="sz-col">' + left + '</div><div class="sz-col">' + right + '</div>';
            if (right) { res.classList.remove('sz-solo'); } else { res.classList.add('sz-solo'); }
        }
        cursor = -1;
        showStart(false);
        setAll(term);
    }

    function items() {
        var list = [];
        if (res && !res.hidden) each(res.querySelectorAll('a'), function (n) { list.push(n); });
        if (allLink && !allLink.hidden) list.push(allLink);
        return list;
    }

    function move(step) {
        var list = items();
        if (!list.length) return;
        if (cursor >= 0 && list[cursor]) list[cursor].classList.remove('is-on');
        cursor = cursor + step;
        if (cursor < -1) cursor = list.length - 1;
        if (cursor >= list.length) cursor = -1;
        if (cursor < 0) { if (field) field.focus(); return; }
        list[cursor].classList.add('is-on');
        if (list[cursor].scrollIntoView) list[cursor].scrollIntoView({ block: 'nearest' });
    }

    function ask() {
        var term = trim(field ? field.value : '');
        cursor = -1;
        setAll(term);
        if (term.length < MIN) {
            if (ctrl) { ctrl.abort(); ctrl = null; }
            if (res) res.innerHTML = '';
            showStart(true);
            return;
        }
        if (ctrl) ctrl.abort();
        ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        if (res) res.innerHTML = '<p class="sz-note">' + esc(T_WAIT) + '</p>';
        showStart(false);
        /* to samo zawezanie co w wyszukiwarce w naglowku (polskie nazwy kategorii -> product_type) */
        var zapytanie = (typeof window.ngSearchQuery === 'function') ? window.ngSearchQuery(term) : term;
        /* zawezenie do 'title:' blokuje dopasowanie po przedrostku - 'title:ni' zwraca 0,
           samo 'ni' zwraca Nike. Mapowanie kategorii (product_type) zostawiamy. */
        if (zapytanie.indexOf('title:') === 0) { zapytanie = term; }
        var url = BASE + '.json?q=' + encodeURIComponent(zapytanie)
            + '&resources[type]=' + (COLL ? 'product,collection' : 'product')
            + '&resources[limit]=' + LIMIT
            + '&resources[options][unavailable_products]=last'
            /* bez tego Shopify dopasowuje tylko cale slowa - 'ni' nie znajdowalo Nike */
            + '&resources[options][prefix]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (trim(field ? field.value : '') !== term) return;
                render(data, term);
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') return;
                if (res) res.innerHTML = '<p class="sz-note">' + esc(T_EMPTY) + '</p>';
            });
    }

    /* ---------- zdarzenia ---------- */

    /* SJ 16.10: kafelki marek i kategorii w nakladce (np. "Supreme" -> /collections/supreme) - wpisanie
       tej samej nazwy i Enter prowadzi od razu na kategorie. Wysylke formularza obsluguje assets/maks-naglowek.js
       (ten sam skrot dla kolekcji z podpowiedzi); bez trafienia zwykle wyniki. */
    if (window.sjKolZnane && start) {
        var kafle = [];
        each(start.querySelectorAll('a.sz-chip[href]'), function (a) {
            kafle.push({ title: a.textContent, url: a.getAttribute('href') });
        });
        window.sjKolZnane(kafle);
    }

    soloStart(false);
    if (res) res.classList.add('sz-solo');
    root.classList.toggle('sz-start-on', !field || !field.value.trim());

    each(root.querySelectorAll('[data-sz-close]'), function (n) {
        n.addEventListener('click', function () { close(); });
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            if (!field) return;
            window.clearTimeout(timer);
            field.value = '';
            paintClear();
            ask();
            focusField();
        });
    }

    if (field) {
        field.addEventListener('input', function () {
            window.clearTimeout(timer);
            paintClear();
            timer = window.setTimeout(ask, WAIT);
        });
        field.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
            else if (e.key === 'Enter') {
                var list = items();
                if (cursor >= 0 && list[cursor] && list[cursor].href) {
                    e.preventDefault();
                    window.location.href = list[cursor].href;
                }
            }
        });
    }

    if (form) {
        form.addEventListener('submit', function () {
            window.clearTimeout(timer);
            if (ctrl) ctrl.abort();
        });
    }

    root.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !panel) return;
        var all = [];
        each(panel.querySelectorAll('a[href], button, input, select, textarea'), function (n) {
            if (n.disabled || n.type === 'hidden' || n.hidden) return;
            if (n.offsetWidth === 0 && n.offsetHeight === 0) return;
            all.push(n);
        });
        if (!all.length) return;
        var first = all[0];
        var last = all[all.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('keydown', function (e) {
        if (root.hidden) return;
        if (e.key === 'Escape') { e.stopPropagation(); close(); }
    });

    window.addEventListener('resize', function () { if (!root.hidden) { setTop(); setHeight(); } });
    if (vv) {
        vv.addEventListener('resize', function () { if (!root.hidden) setHeight(); });
        vv.addEventListener('scroll', function () { if (!root.hidden) setHeight(); });
    }

    document.addEventListener('click', function (e) {
        var n = e.target;
        if (!n || !n.closest) return;
        var t = n.closest(TRIG);
        if (t) {
            if (!TAKEOVER) return;
            var api = window.maksSzukajka;
            if (!api) return;
            e.preventDefault();
            e.stopPropagation();
            if (root.classList.contains('is-open')) {
                t.setAttribute('aria-expanded', 'false');
                api.close();
                return;
            }
            t.setAttribute('aria-expanded', 'true');
            api.open();
            return;
        }
        if (root.hidden || root.contains(n)) return;
        if (n.tagName === 'INPUT' && n.getAttribute('name') === 'q') return;
        if (n.closest('[data-ng-head], .shopify-section-group-header-group')) close();
    }, TAKEOVER);

    if (GRAB) {
        document.addEventListener('mousedown', function (e) {
            var n = e.target;
            if (!n || !n.closest || root.contains(n)) return;
            if (n.tagName !== 'INPUT' || n.getAttribute('name') !== 'q') return;
            if (!n.closest('[data-ng-head], .shopify-section-group-header-group')) return;
            if (n.closest('.ng-drawer')) return;
            e.preventDefault();
            var v = n.value;
            open();
            if (v && field) {
                field.value = v;
                paintClear();
                window.clearTimeout(timer);
                timer = window.setTimeout(ask, WAIT);
            }
        }, true);
    }

    document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(root)) open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(root)) close();
    });
    document.addEventListener('shopify:block:select', function (e) {
        if (e.target && root.contains(e.target)) open();
    });
    document.addEventListener('shopify:section:unload', function (e) {
        if (!e.target || !e.target.contains(root)) return;
        if (!root.hidden) lock(false);
        if (window.maksSzukajka && window.maksSzukajka.open === open) window.maksSzukajka = null;
    });
})();
};
SZV_INIT();
document.addEventListener('shopify:section:load', function () { SZV_INIT(); });
